module.exports = __webpack_public_path__ + "img/client4.455c5491.png";